import { DOCUMENT } from '@angular/common';
import {
  ComponentFactoryResolver,
  Inject,
  Injectable,
  Injector,
} from '@angular/core';
import { Subject } from 'rxjs';
import { ModalComponent } from '../modal.component';
import { ModalInterface } from '../types/modal.interface';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private modalNotifier?: Subject<string>;
  constructor(
    private resolver: ComponentFactoryResolver,
    @Inject(DOCUMENT) private documnet: Document,
    private injector: Injector
  ) {}

  open(options?: ModalInterface) {
    const modalComponentFactory =
      this.resolver.resolveComponentFactory(ModalComponent);
    let modalComponent;
    if (options?.content) {
      const contentViewRef = options.content.createEmbeddedView(null);
      modalComponent = modalComponentFactory.create(this.injector, [
        contentViewRef.rootNodes,
      ]);
    } else {
      modalComponent = modalComponentFactory.create(this.injector);
    }
    modalComponent.instance.size = options?.size;
    modalComponent.instance.title = options?.title;
    modalComponent.instance.message = options?.message;
    modalComponent.instance.submitLabel = options?.submitLabel;
    modalComponent.instance.cancelLabel = options?.cancelLabel;
    modalComponent.instance.showHeader = options?.showHeader;
    modalComponent.instance.alignCenter = options?.alignCenter;
    modalComponent.instance.showCancelBtn = options?.showCancelBtn;

    modalComponent.instance.closeEvent.subscribe(() => this.closeModal());
    modalComponent.instance.submitEvent.subscribe(() => this.submitModal());

    modalComponent.hostView.detectChanges();
    this.documnet.body.appendChild(modalComponent.location.nativeElement);

    this.modalNotifier = new Subject();
    return this.modalNotifier.asObservable();
  }

  closeModal() {
    this.modalNotifier?.complete();
  }

  submitModal() {
    this.modalNotifier?.next('confirm');
    this.closeModal();
  }
}
